<template>
  <br />
  <div class="block">
    <div class="boxx">
      <h4>Forums</h4>
      <p
        style="font-size: 19px; font-weight: 400; line-height: 1.4; color: #333"
      >
        You may use the forums to search for queries. Please create a user
        account which will allow access to the search facilities, new posts
        and/or adding additional information to a current post. Click on
        ‘Register’ at the top right-hand side and follow the instructions.
      </p>
      <p
        style="font-size: 19px; font-weight: 400; line-height: 1.4; color: #333"
      >
        To enter the forums,
        <span
          ><a
            class="alink"
            href="https://discourse.datatex.co.za/"
            target="_blank"
            rel="noopener noreferrer"
            ><strong>click here</strong></a
          ></span
        >
      </p>
    </div>
    <br />
    <div class="page-break3"></div>
    <br />
    <br />

    <h4>Downloads</h4>
    <!-- Windows Section -->
    <div class="Win">
      <div class="rounded-background-box">
        <div class="left-rounded-column">
          <div class="product">
            <img
              src="/WindowsLogoImage.png"
              alt="Windows Logo"
              class="icon"
              loading="lazy"
            />
          </div>
        </div>
        <div class="right-rounded-column">
          <div class="product-info">
            <h3 style="color: #00a4ef">Windows:</h3>
            <br />
            <h5>TNG install files for Windows</h5>
            <ul>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/TNG_setup_1_1_1_12.exe"
                  >TNG_setup_1_1_1_12</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/TNGLive_setup_1_1_1_12.exe"
                  >TNGLive_setup_1_1_1_12</a
                >
              </li>
            </ul>
            <h5>TNG Updates for Windows</h5>
            <ul>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tnglive-zarates-update-1_1_1_12.zip"
                  >tnglive-zarates-update-1_1_1_12</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tnglive-zarates-update-1_1_1_12_2014.dtx"
                  >tnglive-zarates-update-1_1_1_12_2014</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tng-zarates-update-1_1_1_12.zip"
                  >tng-zarates-update-1_1_1_12</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tng-zarates-update-1_1_1_12_2014.dtx"
                  >tng-zarates-update-1_1_1_12_2014</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/09/FTDI-Tool.zip"
                  >FTDI-Tool.zip</a
                >
              </li>
            </ul>
            <h5>To install the Windows update</h5>
            <ol>
              <li>
                Make sure that your TNG's subscription has not expired ( See
                License Page ).
              </li>
              <li>Make sure everyone is logged out of TNG.</li>
              <li>
                Run the attatched <code>.dtx</code> file on the TNG host PC.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="page-break1"></div>

    <!-- Linux Section -->
    <div class="Win">
      <div class="rounded-background-box">
        <div class="left-rounded-column">
          <div class="product">
            <img
              src="/LinuxLogoImage.png"
              alt="Windows Logo"
              class="icon"
              loading="lazy"
            />
          </div>
        </div>
        <div class="right-rounded-column">
          <div class="product-info">
            <h3 style="color: gold">Linux:</h3>
            <br />
            <h5>TNG install files for Linux</h5>
            <ul>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tng-1.1.1.12-1_all.deb"
                  >tng-1.1.1.12-1_all</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tnglive-1.1.1.12-1_all.deb"
                  >tnglive-1.1.1.12-1_all</a
                >
              </li>
            </ul>
            <h5>TNG Updates for Linux</h5>
            <ul>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tng-live-1.1.1.13.rar"
                  >tng-live 1.1.1.13</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tng-update-1_1_1_12_2014.txt"
                  >tng-update-1_1_1_12_2014</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tng-update-1_1_1_12.txt"
                  >tng-update-1_1_1_12</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tnglive-update-1_1_1_12_2014.txt"
                  >tnglive-update-1_1_1_12_2014</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/tnglive-update-1_1_1_12.txt"
                  >tnglive-update-1_1_1__12</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/09/TNG4ASTERISK_setup_Linux_1.0.7.0.rpm"
                  >TNG4ASTERISK_setup_Linix_1.0.7.0.rpm</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/09/tng-1.0.7.7-1_all.zip"
                  >tng-1.0.7.7-1_all</a
                >
              </li>
            </ul>
            <h5>To install the Linux update</h5>
            <ol>
              <li>
                Make sure that your TNG's subscription has not expired ( See
                License Page ).
              </li>
              <li>Make sure everyone is logged out of TNG.</li>
              <li>
                Run the attached rpm file as follows:
                <code>rpm -i -replacefiles tng-1.0.7.0_za_update-1.rpm</code>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div class="page-break1"></div>
    <br />

    <!-- Documents Section -->
    <div class="Oth">
      <div class="rounded-background-box">
        <div class="left-rounded-column">
          <div class="product">
            <img
              src="https://www.datatex.co.za/wp-content/uploads/2016/06/documents.png"
              alt="Windows Logo"
              class="icon"
              loading="lazy"
            />
          </div>
        </div>
        <div class="right-rounded-column">
          <div class="product-info">
            <h3 style="color: red">Other:</h3>
            <br />
            <h5>Additional Documents</h5>
            <ul>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/TNG-for-Asterisk-installation-Guide-pdf.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  TNG for Asterisk Installation Guide ( PDF )</a
                >
              </li>
              <li>
                <a
                  href="https://www.datatex.co.za/wp-content/uploads/2016/06/TNG-Users-Guide-pdf.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  >TNG User Guide ( PDF )</a
                >
              </li>
            </ul>
            <br />
            <h5>Datatex YouTube</h5>
            <div class="frame">
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/@DatatexDynamics/playlists"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Datatex Dynamics ( video playlists )</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-break2"></div>
    <br />
    <h4>SLA Options</h4>
    <br />
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>DESCRIPTION</th>
            <th>REMOTE MAINTENANCE</th>
            <th>REMOTE MONITORING</th>
            <th>BRONZE</th>
            <th>SILVER</th>
            <th>GOLD</th>
            <th>PLATINUM</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Software Updates</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
          </tr>
          <tr>
            <td>Preferential Telephonic and Email Support</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
          </tr>
          <tr>
            <td>Preventative Maintenance</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
          </tr>
          <tr>
            <td>Continuous Training</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
          </tr>
          <tr>
            <td>Disc Space, Processor and Memory Checks</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
          </tr>
          <tr>
            <td>Check Log Files for Errors</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
          </tr>
          <tr>
            <td>Check Recording Hardware and Software</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
            <td class="check">✓</td>
          </tr>
          <tr>
            <td>Remote Monitoring</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
          </tr>
          <tr>
            <td>Lost Network Connections between Datatex Applications</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
          </tr>
          <tr>
            <td>Disc Space and Memory Running Low</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
          </tr>
          <tr>
            <td>Message Alerts when Critical Applications stop</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
          </tr>
          <tr>
            <td>Improper Shutdown of Hardware</td>
            <td class="cross">✘</td>
            <td class="check">✓</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
            <td class="cross">✘</td>
          </tr>
          <tr>
            <td>Hours Covered</td>
            <td>9am - 5pm Weekdays</td>
            <td>9am - 5pm Weekdays</td>
            <td>9am - 5pm Weekdays</td>
            <td>9am - 5pm Weekdays</td>
            <td>12 x 5</td>
            <td>24 x 7</td>
          </tr>
          <tr>
            <td>Support Hours Included for Preventative Maintenance</td>
            <td>2</td>
            <td>0</td>
            <td>2</td>
            <td>6</td>
            <td>10</td>
            <td>16</td>
          </tr>
          <tr>
            <td>Response Times within Hours Covered</td>
            <td>0.5</td>
            <td>0.5</td>
            <td>12</td>
            <td>8</td>
            <td>6</td>
            <td>4</td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
  </div>
  <br />
</template>

<script>
export default {};
</script>

<style scoped>
.page-break {
  page-break-before: always;
  border: 1px solid #2c4a66;
  width: 80%;
  margin-left: 10%;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.page-break1 {
  page-break-before: always;
  border: 1px solid #888;
  width: 80%;
  margin-left: 10%;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.page-break2 {
  page-break-before: always;
  border: 1px solid #2c4a66;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.page-break3 {
  page-break-before: always;
  border: 1px solid #888;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.block {
  background: white;
  padding: 30px;
  width: 80%;
  margin: 0 auto;
  text-align: left;
}
.block a {
  position: relative;
  text-decoration: none;
  color: #2c4a66;
  transition: color 0.3s ease-in-out;
}

.block a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 2px;
  background-color: #000;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease-in-out;
}

.block a:hover {
  color: #000;
}

.block a:hover::after {
  transform: scaleX(1);
}

h4 {
  color: black;
}

/* ======== tabele styling ======== */

table {
  border-collapse: collapse;
  width: 100%;
  background-color: #ddd;
  box-shadow: 0 5px 20px #555;
}

thead th {
  background-color: #2c4a66;
  color: white;
  width: 120px;
}

th,
td {
  text-align: center;
  padding: 12px;
  border: 2px solid #777;
}

tbody tr:nth-child(even) {
  background-color: white;
}

tbody tr:hover {
  background-color: #ddd;
}

/* Description column (first column) styling */
td:first-child {
  background-color: #2c4a66;
  color: #ffffff;
  font-weight: bold;
  text-align: left;
}

th:first-child {
  text-align: left;
  width: 280px;
}

td {
  font-size: 16px;
}

.check {
  color: green;
  font-weight: bold;
}

.cross {
  color: red;
  font-weight: bold;
}

/* ======== downloads ======== */
.Win {
  height: 500px;
}

.Oth {
  height: 440px;
}

.downloads {
  width: 90%;
  /* padding: 2rem; */
}

h2 {
  text-align: left;
}

.section {
  margin-bottom: 2rem;
  /* border-top: 1px solid #ccc; */
  padding-top: 1.5rem;
}

.section-header {
  justify-content: flex-end;
}

.icon {
  width: 350px;
  height: auto;
  flex-shrink: 0;
  box-shadow: 0 5px 20px #555;
  border-radius: 30px;
}

h3 {
  margin: 0;
}

.content h4 {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

ul {
  list-style: none;
  padding-left: 1rem;
}

ul li::before {
  content: "– ";
  margin-right: 0.25rem;
}

a {
  color: #0056b3;
  text-decoration: none;
}

ol {
  padding-left: 1.5rem;
  margin-top: 0.5rem;
}

code {
  background-color: #ddd;
  padding: 2px 5px;
  border-radius: 4px;
  color: tomato;
}

.rounded-background-box {
  width: auto;
  height: 290px;
  background-color: white;

  z-index: 2;
}

.left-rounded-column {
  position: relative;
  float: right;
  border-radius: 25px 0px 0px 25px;
  height: 290px;
}

.right-rounded-column {
  position: relative;
  float: left;
  height: auto;
  width: 49%;
}

.product-info {
  display: inline-block;
  position: relative;
  height: 60px;
  margin-top: 30px;
}

.product-info p {
  display: inline-block;
  position: relative;
  margin-right: 50px;
}

.product-info h1 {
  line-height: 40px;
}

.product {
  position: relative;
  width: auto;
  height: auto;
  background-color: transparent;
  z-index: 100;
}

.tablet {
  position: absolute;
  width: 400px;
  height: auto;
  background-color: transparent;
}

/* Responsive Behavior */
@media (max-width: 932px) {
  .rounded-background-box {
    flex-direction: column;
    align-items: center;
  }

  .left-rounded-column,
  .right-rounded-column {
    text-align: center;
  }

  .product-info {
    margin-top: 1rem;
    text-align: left;
  }

  .icon {
    width: 150px;
  }
}
@media (max-width: 898px) {
  .rounded-background-box {
    flex-direction: column;
    align-items: center;
  }

  .left-rounded-column {
    display: none;
  }
  .right-rounded-column {
    text-align: center;
    width: 100%;
  }

  .product-info {
    margin-top: 1rem;
    text-align: left;
  }

  .icon {
    display: none;
  }
  .Oth {
    height: auto;
  }
}

@media (max-width: 480px) {
  .icon {
    width: 120px;
  }

  .product-info h3 {
    font-size: 1.2rem;
  }

  .product-info h5 {
    font-size: 1rem;
  }

  ul,
  ol {
    font-size: 0.9rem;
  }
}

@media (max-width: 375px) {
  .page-break1 {
    display: none;
  }
  h3 {
    border-top: 2px solid #888;
  }
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1rem;
  border-radius: 8px;
}

.table-responsive table {
  min-width: 700px; /* or however wide your full table needs to be */
}
</style>
